import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteUserConnectedDevicesParams {
  userId: string;
  deviceIds: string[];
}

export class DeleteUserConnectedDevicesRequest extends Request<IDeleteUserConnectedDevicesParams, IResult> {
  constructor(params: IDeleteUserConnectedDevicesParams) {
    super('deleteUserConnectedDevices', params);
  }
}
